import { IShader } from '../shaders/shader';
import { ProductType } from '@/store/modules/product';
import store from '@/store';

export class Legs {

    constructor(
        public model: string,
        public light: string,
        public shader: IShader,
        public height: number,
        public type: ProductType = ProductType.CHEST_FURNITURE,
        public avatar: string = shader.avatar,
        public realHeight: number = 0,
    ) { }
}

// tslint:disable-next-line:max-classes-per-file
export class CoffeeTableLegs extends Legs {
    constructor(
        public model: string,
        public light: string,
        public shader: IShader,
        public height: number,
        public type: ProductType = ProductType.CHEST_FURNITURE,
        public avatarTemplate: string = shader.avatar,
        public realHeight: number = 0,
    ) {
        super(
            model,
            light,
            shader,
            height,
            type,
            avatarTemplate,
            realHeight,
        );
    }

    public get avatar() {
        const big = store.getters.product.height === 450;
        return big ?
            this.avatarTemplate.replace('_icon', '_wys_icon') :
            this.avatarTemplate;
    }

    public set avatar(value: string) {
        return;
    }
}
